module.exports = __webpack_public_path__ + "f2ec61c01462efc2e1803679a7d95cf7.svg";